import type { ReactNode } from 'react';
import { Spinner } from '@viana-demos/ui';
import { useAuth } from './useAuth';
import { AccessDenied } from './AccessDenied';

/**
 * Gates the whole application on the GodLike realm role.
 *
 * This check is COSMETIC — it only avoids rendering a UI that would fail every request. The real
 * boundary is apps/api, where KeycloakJwtGuard + RolesGuard run globally. Never treat a passing
 * check here as authorisation for anything.
 *
 * Children do not mount until the role is confirmed, so no demo query can fire for a user who is
 * not allowed to see the data.
 */
export function RequireGodLike({ children }: { children: ReactNode }) {
  const { ready, authenticated, isGodLike } = useAuth();

  if (!ready || !authenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-viana-grid">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (!isGodLike) return <AccessDenied />;

  return <>{children}</>;
}
